module.exports = __webpack_public_path__ + "static/media/phone.2cdb15b7.svg";